import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Linkedin, Mail, MapPin } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await fetch('https://cru-forms.cruio.workers.dev/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          company: formData.company,
          message: formData.message
        })
      });
      if (response.ok) {
        setFormData({
          name: '',
          email: '',
          company: '',
          message: ''
        });
        alert("Thanks! We'll be in touch.");
      } else {
        alert('Something went wrong. Please try again.');
      }
    } catch (error) {
      alert('Something went wrong. Please try again.');
    }
    setIsSubmitting(false);
  };
  return <main className="flex-grow bg-[#F2F4F0]" data-id="element-211">
      {/* 1. HERO SECTION */}
      <section className="py-20 md:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-212">
        <h1 className="text-5xl md:text-6xl font-serif font-semibold text-text mb-6" data-id="element-213">
          Contact
        </h1>
        <p className="text-xl md:text-2xl text-muted font-sans max-w-3xl mx-auto" data-id="element-214">
          Let's talk about your project.
        </p>
      </section>

      {/* 2. CONTACT FORM SECTION */}
      <section className="pb-16 md:pb-24 px-4 sm:px-6 lg:px-8" data-id="element-215">
        <div className="max-w-2xl mx-auto" data-id="element-216">
          <div className="bg-white p-8 md:p-12 rounded shadow-warm border border-border" data-id="element-217">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-218">
              <div data-id="element-219">
                <label htmlFor="name" className="block text-sm font-semibold text-text mb-2" data-id="element-220">
                  Name
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 rounded border border-border bg-white text-text placeholder:text-muted focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all" placeholder="Your name" data-id="element-221" />
              </div>

              <div data-id="element-222">
                <label htmlFor="email" className="block text-sm font-semibold text-text mb-2" data-id="element-223">
                  Email
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 rounded border border-border bg-white text-text placeholder:text-muted focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all" placeholder="you@example.com" data-id="element-224" />
              </div>

              <div data-id="element-225">
                <label htmlFor="company" className="block text-sm font-semibold text-text mb-2" data-id="element-226">
                  Company{' '}
                  <span className="text-muted font-normal" data-id="element-227">(optional)</span>
                </label>
                <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-3 rounded border border-border bg-white text-text placeholder:text-muted focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all" placeholder="Your company" data-id="element-228" />
              </div>

              <div data-id="element-229">
                <label htmlFor="message" className="block text-sm font-semibold text-text mb-2" data-id="element-230">
                  Message
                </label>
                <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={5} className="w-full px-4 py-3 rounded border border-border bg-white text-text placeholder:text-muted focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all resize-none" placeholder="Tell us about your project..." data-id="element-231" />
              </div>

              <div className="pt-4" data-id="element-232">
                <Button type="submit" size="lg" className="w-full sm:w-auto" disabled={isSubmitting} data-id="element-233">
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* 3. CONTACT INFO SECTION */}
      <section className="py-16 md:py-24 bg-[#F2F4F0]" data-id="element-234">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-235">
          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16" data-id="element-236">
            <div className="flex items-center gap-3 text-muted" data-id="element-237">
              <MapPin className="w-5 h-5" data-id="element-238" />
              <span className="text-lg" data-id="element-239">Melbourne, Australia</span>
            </div>

            <a href="https://www.linkedin.com/company/cru-io/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-text hover:text-primary transition-colors" data-id="element-240">
              <Linkedin className="w-5 h-5" data-id="element-241" />
              <span className="text-lg" data-id="element-242">LinkedIn</span>
            </a>
          </div>
        </div>
      </section>
    </main>;
}